import { useStaticQuery, graphql } from "gatsby"

const useProjectsQuery = () => {
  return useStaticQuery(graphql`
    query ProjectsQuery {
      allProjects: allWpProject(sort: {date: DESC}) {
        nodes {
          ...ProjectCard
        }
      }
      sectors: allWpSector(filter: {count: {ne: null}}, sort: {name: DESC}) {
        nodes {
          name
          slug
        }
      }
      disciplines: allWpDiscipline(filter: {count: {ne: null}}) {
        nodes {
          name
          slug
        }
      }
    }
  `)
}

export default useProjectsQuery